var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiroute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54708C",
    fillRule: "nonzero",
    d: "M19.95 7.963l2.828 2.828a1 1 0 0 1 0 1.415l-2.828 2.828a1 1 0 0 1-1.414-1.414l1.12-1.122h-4.327a3.001 3.001 0 0 1-5.658 0H6.829a3.001 3.001 0 1 1 0-2h2.842a3.001 3.001 0 0 1 5.658 0h4.327l-1.12-1.12a1 1 0 1 1 1.414-1.415zM4 10.498a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiroute);
export default __webpack_public_path__ + "static/media/multiroute.d95a230d9f4ad6abec9c3e5240d76744.svg";
export { ForwardRef as ReactComponent };